"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = require("@airstudio/state");
const react_redux_1 = require("react-redux");
exports.useWorkspace = () => {
    return react_redux_1.useSelector(state_1.Selectors.Workspaces.getActiveWorkspaceId);
};
//# sourceMappingURL=workspace.js.map